export class State {
  constructor(private _state: string) {}

  get state(): string {
    return this._state;
  }
}
